class VXPropTypes {
	/**
	 * @link https://reactjs.org/docs/typechecking-with-proptypes.html
	 *
	 * @param {Object} props
	 * @param {String} propName
	 * @param {String} componentName
	 * @return {?Error}
	 */
	static requiredOnMobile(props, propName, componentName) {
		// onChange is required for mobile view only
		if (props.isMobile && typeof props[propName] === "undefined") {
			return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`. It is required for mobile view.');
		}
	}
}

export default VXPropTypes;
